/* Firestore client handle. The public site reads published content
   and media here; admin writes are added in Phase 3. */
import { getFirestore } from 'firebase/firestore'
import { app } from './firebase.js'

export const db = getFirestore(app)
